// BreadcrumbsSkeleton.js
import React from "react";
import { Skeleton } from "@heroui/skeleton";

export default function BreadcrumbsSkeleton() {
  return (
    <div className="breadcrumbs xl:container mx-auto mt-10 mb-10">
      <div className="mb-6 text-sm text-1B51CA">
        <Skeleton className="h-4 w-24 inline-block rounded-lg mr-2" />
        🔹
        <Skeleton className="h-4 w-24 inline-block rounded-lg mx-2" />
        🔹
        <Skeleton className="h-4 w-36 inline-block rounded-lg ml-2" />
      </div>
    </div>
  );
}
